'use strict'

import BaseService from './baseService'
import { Constants } from '../utils/constants'

const serviceURL = `/api/${Constants.BASE_API_VERSION}/monthEnd`

export default class MonthEndService extends BaseService {
  async run (location, monthAndYear) {
    let url = `${serviceURL}/run/?location=${location}&monthAndYear=${monthAndYear}`
    return this.sendRequest('POST', url)
  }
}
